import { Checkbox as MaterialCheckbox } from '@mui/material';
import { TableCell as MaterialTableCell } from '@mui/material';

import { Tooltip } from 'ui';

export interface Row<T> {
  id: string;
  data: T;
}

interface Props<T> {
  isItemSelected: boolean;
  row: Row<T>;
  handleSelect: (event: React.MouseEvent<unknown>, id: string) => void;
  isLastItem: boolean;
  disabled?: boolean;
  tooltip?: string;
  hasExpandableRows?: boolean;
}

export const TableCheckboxCell = <T,>(props: Props<T>) => {
  return (
    <MaterialTableCell
      padding="none"
      sx={{
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        p: 0,
        pl: props.hasExpandableRows ? 0 : '0.75rem',
        width: '30px',
        borderBottom: (theme) => (props.isLastItem ? 'none' : `0.016rem solid ${theme.palette.divider}`)
      }}
    >
      {props.disabled && props.tooltip ? (
        <Tooltip title={props.tooltip}>
          <MaterialCheckbox
            checked={props.isItemSelected}
            color="primary"
            onClick={(event) => props.handleSelect(event, props.row.id)}
            data-cy="select-checkbox"
            sx={{
              p: 0,
              color: (theme) => theme.palette.text.disabled,
              '&.Mui-checked': {
                color: (theme) => theme.palette.text.disabled
              },
              '&.Mui-checked .MuiSvgIcon-root': {
                color: (theme) => theme.palette.text.disabled
              }
            }}
            disabled={props.disabled}
          />
        </Tooltip>
      ) : (
        <MaterialCheckbox
          checked={props.isItemSelected}
          color="primary"
          onClick={(event) => props.handleSelect(event, props.row.id)}
          data-cy="select-checkbox"
          sx={{
            p: 0,
            color: (theme) => theme.palette.text.disabled,
            '&.Mui-checked': {
              color: (theme) => theme.palette.text.disabled
            },
            '&.Mui-checked .MuiSvgIcon-root': {
              color: (theme) => theme.palette.text.disabled
            }
          }}
          disabled={props.disabled}
        />
      )}
    </MaterialTableCell>
  );
};
